import React from 'react';
import Spinner from '@dbk/ui-spinner'
import Loading from './loading';

function LoadingCircle({isPage, noPadding}) {
  return (
    <Loading
      content={<Spinner/>}
      isPage={isPage} 
      noPadding = {noPadding}
    />
  );
}

export default LoadingCircle;
